import {
  CUSTODIAN_CHANGE_STATE_MODES,
  MANAGER_CHANGE_STATE_MODES
} from "./pettycash";

export const REASON = {
  REQUEST_FOR_RETURN_PETTY_CASH: {
    id: CUSTODIAN_CHANGE_STATE_MODES.REQUEST_RETURN,
    action: "ارسال درخواست بازگشت این تنخواه",
    responsible: "مدیران شرکت"
  },
  REJECT_FINALIZED_PETTY_CASH: {
    id: MANAGER_CHANGE_STATE_MODES.REJECT_FINALIZE,
    action: "خارج کردن این تنخواه از حالت قطعی",
    responsible: "همکار شما"
  },
  RETURN_PETTY_CASH_TO_PETTY_CASHIER: {
    id: MANAGER_CHANGE_STATE_MODES.RETURN,
    action: "بازگشت این تنخواه به تنخواه‌دار",
    responsible: "تنخواه‌دار"
  },
  APPROVE_PETTY_CASH: {
    id: MANAGER_CHANGE_STATE_MODES.APPROVE,
    action: "تایید این تنخواه",
    responsible: "مدیران شرکت",
    reasonText: "توضیحات",
    requireDescription: false
  },
  RETURN_PETTY_CASH: {
    id: CUSTODIAN_CHANGE_STATE_MODES.RETURN,
    action: "بازگشت این تنخواه",
    responsible: "همکار شما"
  },
  REJECT_LAST_SIGNATURE: {
    id: MANAGER_CHANGE_STATE_MODES.REJECT,
    action: "بازگشت آخرین تایید تنخواه",
    responsible: "همکار شما"
  }
};
